import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Toast} from 'primeng/toast';
import {PrimeTemplate} from 'primeng/api';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast, PrimeTemplate],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'pedidos-B2B';
}
